module.exports = __webpack_public_path__ + "img/ennetix-users-page-office-zone-tab2.68b04332.png";